import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gstar-comment-field',
  templateUrl: './comment-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentFieldComponent {
  comment = input<string>('');
  title = input<string>('');
}
